import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter, GridToolbarFilterButton, GridToolbarColumnsButton } from '@mui/x-data-grid';
import { adminDataGridSx } from '../utils/dataGridStyles';

function Toolbar() {
  return (
    <Box sx={{ display: 'flex', gap: 1, p: '4px 8px', borderBottom: '1px solid #e0e0e0', alignItems: 'center' }}>
      <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      <Box sx={{ flex: 1 }} />
      <GridToolbarQuickFilter size="small" />
    </Box>
  );
}

const COLUMNS = [
  {
    field: 'user_id',
    headerName: 'User',
    flex: 1,
    minWidth: 180,
    valueGetter: (params) => params.row.user_id || '(anonymous)',
  },
  {
    field: 'calls',
    headerName: 'Calls',
    type: 'number',
    width: 90,
    valueGetter: (params) => Number(params.row.calls),
  },
  {
    field: 'tokens_in',
    headerName: 'Tokens In',
    type: 'number',
    width: 110,
    valueGetter: (params) => Number(params.row.tokens_in),
    valueFormatter: ({ value }) => Number(value).toLocaleString(),
  },
  {
    field: 'tokens_out',
    headerName: 'Tokens Out',
    type: 'number',
    width: 110,
    valueGetter: (params) => Number(params.row.tokens_out),
    valueFormatter: ({ value }) => Number(value).toLocaleString(),
  },
  {
    field: 'avg_tokens_per_call',
    headerName: 'Avg Tokens/Call',
    type: 'number',
    width: 140,
    valueGetter: (params) => Math.round(Number(params.row.avg_tokens_per_call ?? 0)),
    valueFormatter: ({ value }) => Number(value).toLocaleString(),
  },
  {
    field: 'cost_usd',
    headerName: 'Est. Cost',
    type: 'number',
    width: 100,
    valueGetter: (params) => Number(params.row.cost_usd),
    valueFormatter: ({ value }) => `$${Number(value).toFixed(4)}`,
  },
  {
    field: 'avg_latency_ms',
    headerName: 'Avg Latency',
    type: 'number',
    width: 120,
    valueGetter: (params) => Math.round(Number(params.row.avg_latency_ms ?? 0)),
    valueFormatter: ({ value }) => `${Number(value).toLocaleString()} ms`,
  },
  {
    field: 'error_count',
    headerName: 'Errors',
    type: 'number',
    width: 80,
    valueGetter: (params) => Number(params.row.error_count ?? 0),
  },
];

export default function AiUsageUserTable({ rows, loading, onUserClick }) {
  if (loading) return <Skeleton variant="rectangular" height={200} sx={{ mt: 1 }} />;

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>BY USER</Typography>
      <DataGrid
        rows={rows || []}
        columns={COLUMNS}
        getRowId={row => row.user_id ?? '(anonymous)'}
        autoHeight
        density="compact"
        pageSizeOptions={[25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        onRowClick={({ row }) => onUserClick && onUserClick(row.user_id)}
        slots={{ toolbar: Toolbar }}
        sx={{ ...adminDataGridSx, cursor: 'pointer' }}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
